const _temp0 = require("./all-in-one-turquoise.svg");
const _temp1 = require("./all-in-one.svg");
const _temp2 = require("./arrow-black.svg");
const _temp3 = require("./arrow-down.svg");
const _temp4 = require("./arrow-left.svg");
const _temp5 = require("./arrow-right.svg");
const _temp6 = require("./arrow-up.svg");
const _temp7 = require("./arrow.svg");
const _temp8 = require("./broadcast-disabled-white.svg");
const _temp9 = require("./broadcast-disabled.svg");
const _temp10 = require("./broadcast-turquoise.svg");
const _temp11 = require("./broadcast.svg");
const _temp12 = require("./close.svg");
const _temp13 = require("./conference.svg");
const _temp14 = require("./interactivity-turquoise.svg");
const _temp15 = require("./interactivity.svg");
const _temp16 = require("./player-turquoise.svg");
const _temp17 = require("./player.svg");
const _temp18 = require("./production-turquoise.svg");
const _temp19 = require("./production.svg");
const _temp20 = require("./replay.svg");
module.exports = {
  "all-in-one-turquoise": _temp0,
  "all-in-one": _temp1,
  "arrow-black": _temp2,
  "arrow-down": _temp3,
  "arrow-left": _temp4,
  "arrow-right": _temp5,
  "arrow-up": _temp6,
  "arrow": _temp7,
  "broadcast-disabled-white": _temp8,
  "broadcast-disabled": _temp9,
  "broadcast-turquoise": _temp10,
  "broadcast": _temp11,
  "close": _temp12,
  "conference": _temp13,
  "interactivity-turquoise": _temp14,
  "interactivity": _temp15,
  "player-turquoise": _temp16,
  "player": _temp17,
  "production-turquoise": _temp18,
  "production": _temp19,
  "replay": _temp20
}